
















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GalaPowerBar from './GalaPowerBar.vue';
import { State } from 'vuex-class';

@Component({
  components: {
    GalaPowerBar,
  },
})
export default class GalaPowerPanel extends Vue {
  @Prop(Boolean) readonly showWalletPrompt!: boolean;
  @State(profile => profile.user.galaPower, { namespace: 'profile' })
  readonly galaPower!: number;

  level = 0;
  powerBarPercent = 0;

  @Watch('galaPower', { immediate: true, deep: true })
  onPowerChanged() {
    this.level = Math.floor(this.galaPower);
    setTimeout(() => {
      this.powerBarPercent = Math.floor((this.galaPower - this.level) * 100);
    }, 1000);
  }
}
